// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"d3517a32","258":"2490d4a0"}[chunkId] + ".chunk.js";
};